import { Spacing, Typography } from '@persona-id/design-tokens';
import { useRef } from 'react';
import { useButton } from 'react-aria';
import styled from 'styled-components';

import { IconButton } from 'design-system/components/Button';
import { IconButtonProps } from 'design-system/components/Button/IconButton';

export const CalendarContainer = styled.div`
  display: inline-block;
`;

export const CalendarHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${Spacing[2]};
`;

export const CalendarHeading = styled.div`
  ${Typography.TextLargeBold};
  flex: 1;
  text-align: center;
`;

const StyledCalendarButton = styled(IconButton)`
  width: 32px;
  height: 32px;
`;

export const CalendarButton = (props: IconButtonProps) => {
  const ref = useRef();
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const { buttonProps } = useButton(props, ref);

  return (
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    <StyledCalendarButton {...buttonProps} className={props.className} ref={ref}>
      {props.children}
    </StyledCalendarButton>
  );
};
